import { combineEpics } from "redux-observable";
import { epicInventoryInfo } from "./epicInventoryInfo";
import { epicInventoryInfoRequestAdd } from "./epicInventoryInfoRequestAdd";
export var epicInventory = combineEpics(epicInventoryInfo, epicInventoryInfoRequestAdd);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/epicInventory.ts
// module id = 1903
// module chunks = 3